import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MultiTenantCreateRequest } from '../../types/multiTenantRequest'

const useCreateMultiTenantRequest = (clusterId: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (newRequest: MultiTenantCreateRequest) =>
			api.multiTenantRequests.createMultiTenantRequest(newRequest),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['multiTenantRequests', clusterId]
			})
		}
	})
}

export default useCreateMultiTenantRequest
